/**
 * Number of recommendation cards to prefetch ahead of current visible cards.
 * Adjust this value based on user swipe speed and network conditions.
 */
export const PREFETCH_CARD_COUNT = 2;
